import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const ordenarEventos = (eventos) => {
  const hoy = moment();
  const inicioSemana = moment().startOf('week');
  const finSemana = moment().endOf('week');
  const inicioMes = moment().startOf('month');
  const finMes = moment().endOf('month');

  // Función helper para obtener la fecha de comparación de un objeto fecha
  const obtenerFechaComparacion = (fecha) => {
    return fecha.Fecha ? moment(fecha.Fecha) : moment(fecha.Inicio);
  };

  // Función helper para verificar si una fecha es válida y futura/actual
  const esFechaValida = (fecha) => {
    if (fecha.Fecha) {
      return moment(fecha.Fecha).isSameOrAfter(hoy, "day");
    } else if (fecha.Inicio && fecha.Fin) {
      return hoy.isBetween(moment(fecha.Inicio), moment(fecha.Fin), "day", "[]") ||
             moment(fecha.Inicio).isSameOrAfter(hoy, "day");
    }
    return false;
  };

  // Función para determinar la prioridad y fecha de ordenamiento
  const obtenerDatosEvento = (fechas) => {
    if (fechas.length === 0) return { prioridad: 5, fechaOrden: null }; // Sin fechas válidas

    const primeraFecha = fechas[0];
    const fechaComparacion = obtenerFechaComparacion(primeraFecha);

    // Verificar si es un evento vigente de meses pasados
    const esEventoVigentePasado = () => {
      if (primeraFecha.Inicio && primeraFecha.Fin) {
        const inicioEvento = moment(primeraFecha.Inicio);
        const finEvento = moment(primeraFecha.Fin);

        return inicioEvento.isBefore(inicioMes) &&
               hoy.isBetween(inicioEvento, finEvento, "day", "[]");
      }
      return false;
    };

    // PRIORIDAD 1: Eventos de esta semana
    if (fechaComparacion.isBetween(inicioSemana, finSemana, "day", "[]")) {
      return { prioridad: 1, fechaOrden: fechaComparacion };
    }

    // PRIORIDAD 2: Eventos del mes actual (pero no de esta semana)
    if (fechaComparacion.isBetween(inicioMes, finMes, "day", "[]")) {
      return { prioridad: 2, fechaOrden: fechaComparacion };
    }

    // PRIORIDAD 3: Eventos vigentes de meses pasados (se ordenan al final de agosto)
    if (esEventoVigentePasado()) {
      // Usamos el final del mes actual como fecha de ordenamiento para que aparezcan al final de agosto
      return { prioridad: 3, fechaOrden: moment(finMes).add(1, 'day') };
    }

    // PRIORIDAD 4: Eventos futuros de otros meses
    return { prioridad: 4, fechaOrden: fechaComparacion };
  };

  // Función para comparar dos fechas
  const compararFechas = (fechaA, fechaB) => {
    const momentoA = obtenerFechaComparacion(fechaA);
    const momentoB = obtenerFechaComparacion(fechaB);

    if (momentoA.isBefore(momentoB, "day")) return -1;
    if (momentoA.isAfter(momentoB, "day")) return 1;
    return 0;
  };

  const eventosOrdenados = eventos
    .map((evento) => {
      // Filtrar fechas válidas y futuras
      const fechasValidas = evento.Fechas?.filter(esFechaValida) || [];

      // Ordenar las fechas del evento
      fechasValidas.sort(compararFechas);

      const datosEvento = obtenerDatosEvento(fechasValidas);

      return {
        evento: evento,
        fechas: fechasValidas,
        prioridad: datosEvento.prioridad,
        fechaOrden: datosEvento.fechaOrden
      };
    })
    .filter(item => item.fechas.length > 0 && item.prioridad < 5) // Solo eventos con fechas válidas
    .sort((a, b) => {
      // Primero ordenar por prioridad
      if (a.prioridad !== b.prioridad) {
        return a.prioridad - b.prioridad;
      }

      // Dentro de la misma prioridad, ordenar por fecha de ordenamiento
      if (a.fechaOrden && b.fechaOrden) {
        if (a.fechaOrden.isBefore(b.fechaOrden, "day")) return -1;
        if (a.fechaOrden.isAfter(b.fechaOrden, "day")) return 1;
      }

      return 0;
    });

  return eventosOrdenados;
};

export default ordenarEventos;